import { getFieldsOwned } from "../../../../../actions/Utilities/EmailRecipient";
import { useQuery } from "react-query";

export default function useFieldsOwned() {
  return useQuery("GetFieldsOwned", getFieldsOwned, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
